import React from "react";
import TextLink from "../atoms/TextLink";
import ImageIcon from "../atoms/ImageIcon";
import PropTypes from "prop-types";

function NavLink({ src, label, href }) {
  return (
    <div className="w-22 h-10 flex items-center ">
      {/* <ImageIcon src={src}></ImageIcon> */}
      <TextLink
        href={href}
        className="text-black  text-base ml-1 font-semibold text-md my-1">
        {label}
      </TextLink>
    </div>
  );
}

export default NavLink;
NavLink.propTypes = {
  src: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
};
